import { httpsCallable } from "firebase/functions";
import { functions } from "@/config/firebase";
import { getLanguageMeta, type SupportedLanguage } from "@/i18n/config";

type TranslateTextInput = {
  texts: string[];
  targetLanguage: string;
  sourceLanguage?: string;
};

type TranslateTextResponse = {
  ok: true;
  translations: string[];
};

export async function translateTextsWithGoogle(
  texts: string[],
  targetLanguage: SupportedLanguage,
  sourceLanguage?: string
) {
  if (targetLanguage === "pt-BR" || texts.length === 0) {
    return texts;
  }

  const translateText = httpsCallable<TranslateTextInput, TranslateTextResponse>(
    functions,
    "geoApp-translateText"
  );
  const input: TranslateTextInput = {
    texts,
    targetLanguage: getLanguageMeta(targetLanguage).googleCode
  };

  if (sourceLanguage) {
    input.sourceLanguage = sourceLanguage;
  }

  const result = await translateText(input);

  return result.data.translations;
}
